import EnemySlot from "./EnemySlot.js";
import Game from "../../Game.js";
import SpeedBar from "./SpeedBar.js";
import Pqp from "../../../3x1010/Pqp.js";
import Screen from "../Screen.js";
import FightLogger from "./FightLogger.js";
import Bout from "../../bout/Bout.js";
import Player from "../../bout/Player.js";
import AttackWithWeapon from "./AttackWithWeapon.js";
import Skills from "../skills/Skills.js";

export default class Fight {
	constructor(heroMob, enemy, enemiesList, directions, callback) {
		this.heroMob = heroMob;
		this.callback = callback;
		this.enemy = enemy;
		this.enemiesList = enemiesList;
		this.mainLoopEnabled = true;
		this.currentTarget = 0;
		this.died = new Array();
		this.directions = directions;
		this.rounds = new Array();
		this.helpers = new Array();
		this.fightEnded = false;
		this.stackIndex = enemy.stackIndex;

	}
	init() {
		this.mc = jQuery("#template-fight").clone();
		this.mc.attr("id", "fight" + Fight.ENUM++);
		this.areaMobs = jQuery(".js-mobs", this.mc);

		this.buildIntro();

	}

	buildIntro() {
		let initiative = this.checkInitiavite();
		Bout.incStatistic(Bout.STAT_FIGHTS, 1);
		if (initiative === 0) {
			// normale
			jQuery(".js-text-event", this.mc).text("An encounter!")
			jQuery(".js-text-event", this.mc).addClass("fight-event-encounter");
			Bout.incStatistic(Bout.STAT_ENCOUNTER_NORMAL, 1);
		} else if (initiative === 1) {
			// hero
			jQuery(".js-text-event", this.mc).text("Surprise attack!")
			jQuery(".js-text-event", this.mc).addClass("fight-event-offguard");
			Bout.incStatistic(Bout.STAT_ENCOUNTER_SURPRISE, 1);
		} else {
			//mob
			jQuery(".js-text-event", this.mc).text("Ambushed!")
			jQuery(".js-text-event", this.mc).addClass("fight-event-ambush");
			Bout.incStatistic(Bout.STAT_ENCOUNTER_AMBUSH, 1);
		}

		setTimeout(this.build.bind(this,initiative), 2000);
	}


	getClip() {
		return this.mc;
	}

	build(initiative) {
		jQuery(".js-fight-event", this.mc).remove();
		////setTimeout(this.endFight.bind(this),2000)
		
		this.createHero(initiative);
		this.createEnemies(initiative);
		this.placeSlots();
		this.setHelperSlots();
		this.attack = new AttackWithWeapon(jQuery(".js-weapon", this.mc), this.mc);
		this.attack.init();

		this.initMainLoop();
		this.logger = new FightLogger(jQuery(".js-messages", this.mc));



	}

	endFight() {
		this.dispatch({ type: Fight.EVENT_WON });
	}

	dispatch(e) {
		if (this.callback) {
			this.callback.call(null, e);
		}
	}

	checkInitiavite() {
		let o = this.directions;
		let initiative = 0;
		if ((o.hero.facing === "n") && (o.mob.facing === "n")) {
			if (o.hero.top < o.mob.top) {
				initiative = 2; // mob
			} else {
				initiative = 1; // hero
			}
		} else if ((o.hero.facing === "s") && (o.mob.facing === "s")) {
			if (o.hero.top > o.mob.top) {
				initiative = 2; // mob
			} else {
				initiative = 1; // hero
			}
		} else if ((o.hero.facing === "e") && (o.mob.facing === "e")) {
			if (o.hero.left > o.mob.left) {
				initiative = 2; // mob
			} else {
				initiative = 1; // hero
			}
		} else if ((o.hero.facing === "w") && (o.mob.facing === "w")) {
			if (o.hero.left < o.mob.left) {
				initiative = 2; // mob
			} else {
				initiative = 1; // hero
			}
		}
		return initiative;
	}



	createHero(initiative) {
		this.hero = new EnemySlot(this.enemy,this.heroMob, null, this.actionEventsHandler.bind((this)));
		this.hero.init(initiative);
		this.hero.mc.addClass("mob-slot-0");

	}

	createEnemies(initiative) {
		let a = this.enemiesList;
		this.enemies = new Array();
		for (let x = 0; x < a.length; x++) {
			let enemy = new EnemySlot(this.enemy,a[x], this.hero, this.actionEventsHandler.bind((this)));
			enemy.init(initiative);
			enemy.mc.addClass("mob-slot-" + (x + 1));
			this.enemies.push(enemy);
			if (x == this.currentTarget) {
				enemy.select(true)
			} else {
				enemy.select(false)
			}
		}
	}

	actionEventsHandler(e) {
		if (e.type === SpeedBar.EVENT_BAR_FULL) {
			this.rounds.push(e);
			//this.playRound(e);
		}
		if (e.type === EnemySlot.EVENT_SELECT_ME) {
			this.selectEnemySlot(e.data);
		}


	}

	selectEnemySlot(enemySlot) {
		for (let x = 0; x < this.enemies.length; x++) {
			let slot = this.enemies[x];
			slot.select(false);
			if (slot.id === enemySlot.id) {
				slot.select(true);
				this.currentTarget = x;
			}
		}
	}


	placeSlots() {
		this.areaMobs.append(this.hero.mc)
		for (let x = 0; x < this.enemies.length; x++) {
			this.areaMobs.append(this.enemies[x].mc);
		}
		let total = this.enemies.length + 1;
		this.areaMobs.addClass("area-mobs-" + total);
	}


	initMainLoop(currentDelta) {
		this.updateId = requestAnimationFrame(this.initMainLoop.bind(this));
		let delta = currentDelta - this.previousDelta;
		if (Game.GAME_FPS_LIMIT && delta < Math.floor(1000 / Game.GAME_FPS_LIMIT)) {
			return;
		}
		this.mainLoop();
		this.previousDelta = currentDelta;
	}


	mainLoop() {
		if (this.rounds.length > 0) {
			//console.log(this.rounds.length)
			if (this.mainLoopEnabled) {
				let round = this.rounds.shift();
				//console.log(round)
				if (!round.data.died) {
					this.playRound(round);
				} else {
					//console.log("DDDDDDDDDDDDDDDDDDDD");
					// skips the fight
				}
			}
		} else {
			if (this.mainLoopEnabled) {
				this.hero.loop();
				for (let x = 0; x < this.enemies.length; x++) {
					this.enemies[x].loop();
				}
			}
		}
		//console.log("A")
	}


	playRound(e) {
		this.mainLoopEnabled = false;
		//console.log("NEW ROUND")
		//console.log(e);
		if (e.data.isHero) {
			this.playHeroAttacksEnemy(e);
		} else {
			this.playEnemyAttacksHero(e);

		}
	}

	playHeroAttacksEnemy(e) {
		this.countAnimations = 0;
		this.protagonists = new Array();
		this.checkHeroHitsEnemy(e);
	}

	checkHeroHitsEnemy(e) {
		let enemy = this.enemies[this.currentTarget];
		this.attack.start(enemy, this.playHeroAttacksEnemyFeedback.bind(this, e));

	}

	playHeroAttacksEnemyFeedback(e, hit) {
		//console.log(hit)
		let enemy = this.enemies[this.currentTarget];
		this.hero.mob.setAnimation("attack_e", this.attackEnded.bind(this, e, this.hero, this.hero.mob));

		Bout.incStatistic(Bout.STAT_ATTACKS, 1);

		//hit.esit = Fight.HIT_PARRIED
		if (hit.esit === Fight.HIT_HIT) {
			//console.log(hit)
			//console.log("A");
			enemy.mob.setAnimation("hit_w", this.attackEnded.bind(this, e, enemy, enemy.mob, hit));
			Bout.that.player.checkHeroHitsSkill();
			Bout.incStatistic(Bout.STAT_HITS, 1);
			Bout.incStatistic(Bout.STAT_TOTAL_DAMAGE, hit.damage);
			if (Bout.getStatistic(Bout.STAT_MAX_DAMAGE) < hit.damage) {
				Bout.setStatistic(Bout.STAT_MAX_DAMAGE, hit.damage);
			}
			if (hit.critical) {
				Bout.incStatistic(Bout.STAT_HITS_CRITICAL, 1);
			}

		} else {
			if (hit.esit === Fight.HIT_MISSED) {
				//console.log("B");
				//this.attackEnded(e, enemy, enemy.mob, hit);
				enemy.mob.setAnimation("miss_w", this.attackEnded.bind(this, e, enemy, enemy.mob, hit));
				Bout.that.player.checkHeroMissesSkill();
			} else {
				//console.log("C");
				enemy.mob.setAnimation("parry_w", this.attackEnded.bind(this, e, enemy, enemy.mob, hit));
				Bout.that.player.checkEnemyParriedSkill();
			}
		}
		this.showEsit(hit, this.hero, enemy, true);

	}

	playEnemyAttacksHero(e) {
		this.countAnimations = 0;
		this.protagonists = new Array();
		let hit = this.checkEnemyHitsHero(e.data);
		//console.log(hit);
		e.data.mob.setAnimation("attack_w", this.attackEnded.bind(this, e, e.data, e.data.mob));
		if (hit.esit === Fight.HIT_HIT) {
			//console.log(hit.damage)
			//console.log("A");
			this.hero.mob.setAnimation("hit_e", this.attackEnded.bind(this, e, this.hero, this.hero.mob, hit));
			Bout.that.player.checkEnemyHitsSkill();
			Bout.incStatistic(Bout.STAT_DAMAGE_SUFFERED, hit.damage);
		} else {
			if (hit.esit === Fight.HIT_MISSED) {
				//console.log("B");
				//this.attackEnded(e, this.hero, this.hero.mob, hit);
				this.hero.mob.setAnimation("miss_e", this.attackEnded.bind(this, e, this.hero, this.hero.mob, hit));
				Bout.that.player.checkEnemyMissesSkill();
			} else {
				Bout.incStatistic(Bout.STAT_PARRIED, 1);
				//console.log("C");
				this.hero.mob.setAnimation("parry_e", this.attackEnded.bind(this, e, this.hero, this.hero.mob, hit));
				Bout.that.player.checkHeroParriedSkill();
			}
		}
		this.showEsit(hit, e.data, this.hero, false);

	}

	checkEnemyHitsHero(enemy) {
		//console.log("TO DO - ENEMY VS HERO");
		let esit
		let hp = 0;
		let lCritical = false;

		// Check sul parry dell'hero
		let parry = Bout.that.player.getSkillValue(Skills.SKILL_PARRYING)/1000;
		let levelDiff = enemy.mob.lore.level - Bout.that.player.currentLevel;
		if (levelDiff <= -2) {
			parry = parry * 1.5;
		} else if (levelDiff == -1) {
			parry = parry * 1.25;
		} else if (levelDiff == 1) {
			parry = parry * 0.75;
		} else if (levelDiff >= 2) {
			parry = parry * 0.5;
		}
		if (Pqp.check(parry)) {
			esit = Fight.HIT_PARRIED;
		} else {

			let heroArmour = Screen.that.paperdoll.getArmourValue();
			let enemyDamage = Pqp.rnd(enemy.mob.lore.max_damage, enemy.mob.lore.min_damage);
			if (enemyDamage - heroArmour > 0) {
				esit = Fight.HIT_HIT;
				if (enemyDamage + levelDiff >= enemy.mob.lore.max_damage) {
					if (levelDiff > 2) {
						// sempre critico
						lCritical = true;
					} else {
						if (Pqp.rnd(1) === 0) {
							// critico
							lCritical = true;
						}
					}
				}
				hp = enemyDamage - heroArmour;
				if (lCritical) {
					hp = hp * 2;
				}
			} else {
				let diff = enemy.mob.lore.max_damage - enemyDamage;
				let n = Pqp.rnd(diff);
				if (n < diff / 2) {
					esit = Fight.HIT_PARRIED;
				} else {
					esit = Fight.HIT_MISSED;
				}
			}

		}

		/*let a = [Fight.HIT_HIT, Fight.HIT_MISSED, Fight.HIT_PARRIED];
		let esit = a[Pqp.rnd(a.length - 1)];
		let hp = 0
		if (esit === Fight.HIT_HIT) {
			let damage = Pqp.rnd(enemy.mob.lore.max_damage, enemy.mob.lore.min_damage);
			let armour = Screen.that.paperdoll.getArmourValue();
			hp = damage - armour;
			if (hp <= 0) {
				hp = 0;
				esit = Fight.HIT_PARRIED;
			}
		}*/
		return { damage: hp, esit: esit, critical: lCritical};
	}


	attackEnded(e, slot, mob, hit = null) {

		//console.log("-- " + this.countAnimations);
		this.protagonists.push(mob);
		/*if (mob.isHero()) {
			mob.setAnimation("idle_e");
		} else {
			mob.setAnimation("idle_w");
		}*/


		//console.log(hit)
		if (hit) {
			if (hit.esit === Fight.HIT_HIT) {
				slot.gotDamage(hit.damage);
				if (slot.isHero) {
					this.logger.addLine(FightLogger.DAMAGE, this.getColoredName(e.data), this.getColoredName(this.hero), hit.damage);
					Screen.that.status.update();
				} else {
					this.logger.addLine(FightLogger.DAMAGE, this.getColoredName(this.hero), this.getColoredName(slot), hit.damage);
				}

			} else if (hit.esit === Fight.HIT_MISSED) {
				if (slot.isHero) {
					this.logger.addLine(FightLogger.MISS, this.getColoredName(e.data), this.getColoredName(this.hero), hit.damage);
				} else {
					this.logger.addLine(FightLogger.MISS, this.getColoredName(this.hero), this.getColoredName(slot), hit.damage);
				}

			} else {
				if (slot.isHero) {
					//console.log("Parry HERO")
					this.logger.addLine(FightLogger.PARRY, this.getColoredName(e.data), this.getColoredName(this.hero), hit.damage);
				} else {
					//console.log("Parry ENEMY")
					this.logger.addLine(FightLogger.PARRY, this.getColoredName(this.hero), this.getColoredName(slot), hit.damage);
				}
			}
		}

		this.countAnimations++;
		if (this.countAnimations === 2) {
			for (let x = 0; x < this.protagonists.length; x++) {
				if (this.protagonists[x].isHero()) {
					this.protagonists[x].setAnimation("idle_e");
				} else {
					this.protagonists[x].setAnimation("idle_w");
				}
			}

			let n = this.checkDeaths();
			if (n === 0) {
				this.mainLoopEnabled = true;
			} else if (n === 1) {
				if (this.enemies.length > 0) {
					this.currentTarget = 0;
					this.enemies[0].select(true);
					this.mainLoopEnabled = true;
				} else {
					this.fightEnded = true;
					this.hero.mob.setAnimation("won_s");
					let o = new Object();
					o.xp = this.calculateXp();
					o.level = Bout.that.player.currentLevel;
					let gained = Bout.that.player.incrementXp(o.xp);
					o.newLevel = Bout.that.player.currentLevel;
					Screen.that.status.update();
					Bout.incStatistic(Bout.STAT_SCORE, this.calculateScore());

					this.logger.addLine(FightLogger.HERO_WON, this.getColoredName(this.hero), o);
					if (gained) {
						this.logger.addLine(FightLogger.HERO_LEVEL_UP, this.getColoredName(this.hero), gained);
						this.hero.setHp();
					}
					//console.log(o)
					//console.log("WON!!")
					setTimeout(this.openLoot.bind(this), 1000);
					this.removeHelpers();

				}
			} else if (n === 2) {
				this.fightEnded = true;
				for (let x = 0; x < this.enemies.length; x++) {
					this.enemies[x].mob.setAnimation("won_s");
				}
				this.hero.mob.setAnimation("dead_e");
				this.logger.addLine(FightLogger.HERO_LOST, this.getColoredName(this.hero));
				//console.log("TO DO - Hero defeated!")
				setTimeout(this.gameOver.bind(this), 1500);
				this.removeHelpers();
			}
		}
	}

	gameOver() {
		this.attack.destroy();
		this.dispatch({ type: Fight.EVENT_HERO_DEFEATED });
	}

	calculateXp() {
		let xp = 0;
		for (let x = 0; x < this.died.length; x++) {
			xp += this.died[x].mob.lore.xp;
		}
		return xp;
	}

	calculateScore() {
		let score = 0;
		for (let x = 0; x < this.died.length; x++) {
			score += parseInt(""+this.died[x].mob.lore.score);
		}
		return score;
	}


	getColoredName(slot) {
		let ret = ""
		if (slot.isHero) {
			ret = "<span class='text-yellow'>Hero</span>"

		} else {
			let ht = jQuery(".js-name", slot.mc);
			ret = ht.get(0).outerHTML;
		}
		return ret;

	}

	checkDeaths() {
		if (Bout.that.player.isDead()) {
			// Morto l'eroe
			this.hero.mob.setAnimation("dead_e");
			this.hero.die();
			Bout.incStatistic(Bout.STAT_HERO_DEATHS, 1);
			return 2;
		} else {
			for (let x = 0; x < this.enemies.length; x++) {
				let enemy = this.enemies[x];
				if (enemy.mob.lore.isDead()) {
					// Morto nemico
					this.logger.addLine(FightLogger.DIE, this.getColoredName(enemy));
					enemy.mob.setAnimation("dead_w");
					enemy.die();
					this.died.push(enemy);
					this.enemies.splice(x, 1)
					Bout.incStatistic(Bout.STAT_ENEMIES_KILLED, 1);
					return 1;
				}
			}
		}
		return 0;
	}

	openLoot() {
		this.attack.destroy();
		this.dispatch({ type: Fight.EVENT_OPEN_LOOT, data: { stackIndex: this.stackIndex } });
	}


	showSkillGain(skill, value, inc) {
		this.logger.showSkillGain(skill, value, inc, 800);
	}


	setHelperSlots() {
		for (let x = 0; x < this.helpers.length; x++) {
			this.helpers[x].remove();
		}

		// weapon
		let itemSlot = Screen.that.paperdoll.getCurrentWeaponSlot();
		let cloned = itemSlot.mc.clone();
		cloned.removeAttr("id");
		cloned.css({
			top: 0,
			left: 0
		})
		jQuery(".draggable", cloned).removeClass("draggable");
		jQuery(".js-slot-4", this.mc).append(cloned)
		this.helpers.push(cloned);

		// altro
		for (let x = 10; x < 14; x++) {
			let itemSlot = Screen.that.paperdoll.getSlot("pap" + x);
			//console.log(itemSlot)
			let item = itemSlot.getItem();
			if (item) {
				if (item.isConsumable()) {
					let cloned = itemSlot.mc.clone();
					cloned.removeAttr("id");
					cloned.css({
						top: 0,
						left: 0
					})
					this.helpers.push(cloned);
					jQuery(".js-slot-" + (x - 10), this.mc).append(cloned)
					cloned.on("click", this.useHelperItem.bind(this, itemSlot));
				}
			}
		}
	}

	useHelperItem(itemSlot) {
		if (itemSlot.item.isConsumable()) {
			if (itemSlot.item.heal > 0) {
				// Heal
				if (!this.fightEnded) {
					this.logger.addLine(FightLogger.HERO_HEAL, this.getColoredName(this.hero), itemSlot.item.heal);
				}
				this.healHero(itemSlot.item.heal);
			}
		}
		this.dispatch({ type: Fight.EVENT_USE, data: { item: itemSlot.item, itemSlot: itemSlot, tileWindow: null } });
		this.setHelperSlots();
		this.hero.gotHeal();

		

	}


	showEsit(o, attacker, defender, lHero) {
		//console.log(o)
		//console.log(attacker)
		//console.log(defender)
		let esit = jQuery("#template-esit").clone();
		esit.removeAttr("id");
		if (o.esit === Fight.HIT_HIT) {
			esit.text("-" + o.damage);
			esit.addClass("text-red");
			if (o.critical) {
				esit.addClass("text-critical");
			}

			jQuery(".js-mobs", this.mc).append(esit);
			if (lHero) {
				let pos = defender.mc.position();
				let left = pos.left + defender.mc.width() - 50;
				esit.css({ left: left, top: pos.top + (defender.mc.height() - esit.height()) / 2 });
				esit.hide();
				TweenMax.to(esit, 1, { left: left + 16, delay: 0.4, onStart: this.showEsitClip.bind(this,esit) });
				TweenMax.to(esit, 0.5, { opacity: 0, delay: 0.9 });
			} else {
				let pos = defender.mc.position();
				let left = pos.left - esit.width() + 50;
				esit.css({ left: left, top: pos.top + (defender.mc.height() - esit.height()) / 2 });
				esit.hide();
				TweenMax.to(esit, 1, { left: left - 16, delay: 0.4, onStart: this.showEsitClip.bind(this,esit) });
				TweenMax.to(esit, 0.5, { opacity: 0, delay: 0.9 });
			}

		} else if (o.esit === Fight.HIT_MISSED) {
			esit.text("*miss*");
			esit.addClass("text-yellow")
			jQuery(".js-mobs", this.mc).append(esit);
			if (lHero) {
				let pos = attacker.mc.position();
				let left = pos.left + attacker.mc.width() - 40;
				let top = pos.top + (attacker.mc.height() - esit.height()) / 2;
				esit.css({ left: left, top: top });
				esit.hide();
				TweenMax.to(esit, 1, { top: top - 16, delay: 0.4, onStart: this.showEsitClip.bind(this, esit) });
				TweenMax.to(esit, 0.5, { opacity: 0, delay: 0.9 });
			} else {
				let pos = attacker.mc.position();
				let left = pos.left - esit.width() + 40;
				let top = pos.top + (attacker.mc.height() - esit.height()) / 2;
				esit.css({ left: left, top: top});
				esit.hide();
				TweenMax.to(esit, 1, { top: top - 16, delay: 0.4, onStart: this.showEsitClip.bind(this, esit) });
				TweenMax.to(esit, 0.5, { opacity: 0, delay: 0.9 });
			}

		} else {
			esit.text("*parry*");
			esit.addClass("text-orange")
			jQuery(".js-mobs", this.mc).append(esit);
			if (lHero) {
				let pos = defender.mc.position();
				let left = pos.left - esit.width() + 50;
				let top = pos.top + (defender.mc.height() - esit.height()) / 2;
				esit.css({ left: left, top: top });
				esit.hide();
				TweenMax.to(esit, 1, { top: top - 16, delay: 0.4, onStart: this.showEsitClip.bind(this, esit) });
				TweenMax.to(esit, 0.5, { opacity: 0, delay: 0.9 });
			} else {
				let pos = defender.mc.position();
				let left = pos.left + defender.mc.width() - 50;
				let top = pos.top + (defender.mc.height() - esit.height()) / 2;
				esit.css({ left: left, top: top });
				esit.hide();
				TweenMax.to(esit, 1, { top: top - 16, delay: 0.4, onStart: this.showEsitClip.bind(this, esit) });
				TweenMax.to(esit, 0.5, { opacity: 0, delay: 0.9 });
			}
		}

	}

	showEsitClip(esit) {
		esit.show();
	}

	healHero(hp) {
		let esit = jQuery("#template-esit").clone();
		esit.removeAttr("id");
		esit.text("+" + hp);
		esit.addClass("text-green");
		jQuery(".js-mobs", this.mc).append(esit);
		let pos = this.hero.mc.position();
		let left = pos.left + Math.floor((this.hero.mc.width() - esit.width()) / 2);;
		let top = pos.top + (this.hero.mc.height()) / 2 - esit.height();
		esit.css({ left: left, top: top });
		esit.hide();
		TweenMax.to(esit, 1, { top: top - 16, onStart: this.showEsitClip.bind(this, esit) });
		TweenMax.to(esit, 0.5, { opacity: 0, delay: 0.5 });

	}

	removeHelpers() {
		for (let x = 0; x < this.helpers.length; x++) {
			this.helpers[x].remove();
		}
	}


}

Fight.ENUM = 0;

Fight.EVENT_WON = "eventWon"
Fight.EVENT_OPEN_LOOT = "eventOpenLoot"
Fight.EVENT_HERO_DEFEATED = "eventHeroDefeated"
Fight.EVENT_USE = "eventUse";

Fight.HIT_HIT = "hit";
Fight.HIT_MISSED = "missed";
Fight.HIT_PARRIED = "parried";
Fight.HIT_PARRIED_BY_ENEMY = "parriedByEnemy";
